"use client";

import { FC, ReactNode, createContext, useEffect, useState } from "react";

import MagnifyModal from "@/components/MagnifyModal/MagnifyModal";

interface Props {
  children: ReactNode;
}
interface MagnifyContextProps {
  setFloorPlanModalOpen: (open: boolean) => void;
  setFloorPlanImage: (message: string) => void;
  openZoomModalWithImage: (message: string) => void;
}
export const MagnifyContext = createContext<MagnifyContextProps>({
  setFloorPlanModalOpen: () => {},
  setFloorPlanImage: () => {},
  openZoomModalWithImage: () => {},
});

const MagnifyContextProvider: FC<Props> = ({ children }) => {
  const [floorPlanModalOpen, setFloorPlanModalOpen] = useState<boolean>(false);
  const [floorPlanImage, setFloorPlanImage] = useState<string>("");

  const openZoomModalWithImage = (image: any) => {
    setFloorPlanModalOpen(!floorPlanModalOpen);
    setFloorPlanImage(image);
  };

  return (
    <MagnifyContext.Provider value={{ setFloorPlanModalOpen, setFloorPlanImage, openZoomModalWithImage }}>
      {children}
      {floorPlanModalOpen && <MagnifyModal floorPlanImage={floorPlanImage} closeModal={() => setFloorPlanModalOpen(false)} />}
    </MagnifyContext.Provider>
  );
};
export default MagnifyContextProvider;
